import LocationObject from 'entities/locationObject/model';

import { AddressValidationError } from './AddressValidationError';

export const validateLocationObject = (locationObject: LocationObject): void => {
  if (!locationObject.countryCode) {
    throw new AddressValidationError('Country code is required');
  }
  if (locationObject.countryCode === 'US' && !locationObject.postalCode) {
    throw new AddressValidationError('Postal code is required');
  }
  if (locationObject.countryCode === 'US' && !locationObject.stateCode) {
    throw new AddressValidationError('State code is required');
  }
};
